<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-space-y-4 mb-4">
      <div class="row mb-2">
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.certificateType')
          }}</label>
          <select
            style="width: 100%"
            v-model.number="model.cert_type_id"
            @change="certTypeChange()"
            class="form-control"
          >
            <option
              v-for="(s, index) in certificate_types"
              :key="index"
              :value="s.cert_type_id"
            >
              {{ s.cert_type }}
            </option>
          </select>
          <div class="validate" v-if="errors.has('cert_type_id')">
            {{ errors.first('cert_type_id') }}
          </div>
        </div>
        <div class="col-md-6" v-if="model.cert_type_id == 15">
          <label class="col-label form-label">{{
            $t('certificateOperationPrint.level')
          }}</label>
          <a-input v-model="model.level" class="form-control" />
        </div>
        <div class="col-md-6" v-if="model.cert_type_id == 17">
          <label class="col-label">{{
            $t('certificateOperationPrint.doctorName')
          }}</label>
          <a-input
            type="text"
            class="form-control"
            v-model="model.doctor_name"
          />
        </div>
        <div
          class="col-md-6"
          v-if="
            model.cert_type_id != 3 &&
            model.cert_type_id != 4 &&
            model.cert_type_id != 8 &&
            model.cert_type_id != 9 &&
            model.cert_type_id != 10 &&
            model.cert_type_id != 11 &&
            model.cert_type_id != 17 &&
            model.cert_type_id != 15 &&
            model.cert_type_id != 23
          "
        >
          <label class="mb-3">{{
            $t('certificateOperationPrint.academicYear')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.ac_year_id"
            :options="ac_year_list"
          ></a-select>
          <div class="validate" v-if="errors.has('ac_year_id')">
            {{ errors.first('ac_year_id') }}
          </div>
        </div>
        <div
          class="col-md-6"
          v-if="model.cert_type_id == 8 || model.cert_type_id == 9"
        >
          <label>{{ $t('certificateOperationPrint.class') }}</label>
          <a-select
            style="width: 100%"
            v-model="model.class_id"
            :show-search="true"
            :options="classes"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
          ></a-select>
          <div class="validate" v-if="errors.has('class_id')">
            {{ errors.first('class_id') }}
          </div>
        </div>
        <div class="col-md-6" v-if="model.cert_type_id == 10">
          <label>{{ $t('certificateOperationPrint.position') }}</label>
          <a-select
            style="width: 100%"
            v-model="model.position_id"
            :show-search="true"
            :options="positions"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
          ></a-select>
          <div class="validate" v-if="errors.has('position_id')">
            {{ errors.first('position_id') }}
          </div>
        </div>
      </div>
      <div class="row" v-if="model.cert_type_id == 15">
        <div class="col-md-6">
          <label class="form-label col-label">{{
            $t('certificateOperationPrint.studnetName')
          }}</label>
          <a-input v-model="model.achievement_name" class="form-control" />
        </div>
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.requestDate')
          }}</label>
          <a-date-picker
            v-model="model.request_date"
            :allowClear="false"
            style="width: 100%"
            placeholder="DD-MM-YYYY"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            @change="onChangeRequestDate"
            :class="{
              'is-invalid': errors.has('request_date')
            }"
          />
        </div>
      </div>
      <div class="row" v-if="model.cert_type_id == 17">
        <div class="col-md-6">
          <label class="col-label">{{
            $t('certificateOperationPrint.subjectName')
          }}</label>
          <input
            type="text"
            class="form-control"
            v-model="model.subject_name"
          />
        </div>
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.requestDate')
          }}</label>
          <a-date-picker
            v-model="model.request_date"
            :allowClear="false"
            style="width: 100%"
            placeholder="DD-MM-YYYY"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            @change="onChangeRequestDate"
            :class="{
              'is-invalid': errors.has('request_date')
            }"
          />
        </div>
      </div>
      <div
        class="row"
        v-if="
          model.cert_type_id != 3 &&
          model.cert_type_id != 8 &&
          model.cert_type_id != 9 &&
          model.cert_type_id != 10 &&
          model.cert_type_id != 11 &&
          model.cert_type_id != 17 &&
          model.cert_type_id != 15 &&
          model.cert_type_id != 23
        "
      >
        <div class="col-md-6">
          <label>{{ $t('certificateOperationPrint.mainProgram') }}</label>
          <treeselect
            :options="main_programs"
            :placeholder="$t('report.all')"
            :multiple="true"
            :limit="1"
            v-model="model.acp_id"
            @input="onMainProgramChange"
            :maxHeight="150"
          ></treeselect>
        </div>
        <div class="col-md-6">
          <label>{{ $t('certificateOperationPrint.subProgram') }}</label>
          <ts-loading-banner :loading="fetching">
            <treeselect
              :options="sub_programs"
              :placeholder="$t('report.all')"
              :multiple="true"
              :limit="1"
              v-model="model.acps_id"
              :maxHeight="150"
              @input="onSubProgramChange"
            ></treeselect>
          </ts-loading-banner>
          <div class="validate" v-if="errors.has('acps_id')">
            {{ errors.first('acps_id') }}
          </div>
        </div>
      </div>
      <div class="row" v-if="model.cert_type_id == 20">
        <div class="col-md-6">
          <label>{{ $t('certificateOperationPrint.promotion') }}</label>
          <input v-model="model.promotion" type="number" class="form-control" />
        </div>
      </div>
      <div class="row" v-if="model.cert_type_id == 19">
        <div class="col-md-6">
          <label>{{ $t('certificateOperationPrint.subject') }}</label>
          <ts-loading-banner>
            <a-select
              style="width: 100%"
              v-model="model.subject_id"
              :options="subjects"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            ></a-select>
          </ts-loading-banner>
        </div>
      </div>

      <div
        class="row"
        v-if="model.cert_type_id == 16 || model.cert_type_id == 18"
      >
        <div class="col-md-6">
          <label>{{ $t('thesisRegistration.acTerm') }}</label>
          <ts-loading-banner :loading="fetcTerm">
            <a-select
              style="width: 100%"
              v-model="model.ac_term_id"
              :options="ac_terms"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              @change="acTermChange"
            ></a-select>
          </ts-loading-banner>
        </div>
        <div class="col-md-6">
          <label>{{ $t('certificateOperationPrint.class') }}</label>
          <ts-loading-banner :loading="filterClass">
            <a-select
              style="width: 100%"
              v-model="model.class_id"
              :show-search="true"
              :options="class_options"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            ></a-select>
          </ts-loading-banner>
          <div class="validate" v-if="errors.has('class_id')">
            {{ errors.first('class_id') }}
          </div>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div
        class="row"
        v-if="model.cert_type_id != 17 && model.cert_type_id != 15"
      >
        <div class="col-md-12 text-right">
          <ts-button
            class="btn-block"
            color="primary"
            @click.prevent="search"
            outline
            :waiting="waiting"
            ><i class="fas fa-search"></i> {{ $t('search') }}</ts-button
          >
        </div>
      </div>
      <fieldset v-if="model.cert_type_id != 17 && model.cert_type_id != 15">
        <legend>{{ $t('certificateOperationPrint.studentList') }}</legend>
        <ts-loading-banner :loading="fetchingStudent">
          <div
            class="row mb-2"
            v-if="
              model.cert_type_id == 3 ||
              model.cert_type_id == 11 ||
              model.cert_type_id == 15 ||
              model.cert_type_id == 23
            "
          >
            <div class="col-md-6">
              <label class="required">{{
                $t('certificateOperationPrint.courseName')
              }}</label>
              <a-input type="text" v-model="model.course_name" />
              <div class="text-danger" v-if="errors.has('course_name')">
                {{ errors.first('course_name') }}
              </div>
            </div>
            <div class="col-md-6">
              <label>{{ $t('certificateOperationPrint.levelAndBatch') }}</label>
              <a-input type="text" v-model="model.level_and_batch" />
              <div class="text-danger" v-if="errors.has('level_and_batch')">
                {{ errors.first('level_and_batch') }}
              </div>
            </div>
          </div>
          <div
            class="row mb-2"
            v-if="model.cert_type_id != 17 && model.cert_type_id != 15"
          >
            <div
              :class="
                model.cert_type_id == 3 ||
                model.cert_type_id == 11 ||
                model.cert_type_id == 23 ||
                model.cert_type_id == 4
                  ? 'col-md-3'
                  : 'col-md-6'
              "
            >
              <label class="required">{{
                $t('certificateOperationPrint.requestDate')
              }}</label>
              <a-date-picker
                v-model="model.request_date"
                :allowClear="false"
                style="width: 100%"
                placeholder="DD-MM-YYYY"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                @change="onChangeRequestDate"
                :class="{
                  'is-invalid': errors.has('request_date')
                }"
              />
              <div class="invalid-feedback" v-if="errors.has('request_date')">
                {{ errors.first('request_date') }}
              </div>
            </div>
            <div
              class="col-md-3"
              v-if="model.cert_type_id == 3 || model.cert_type_id == 11"
            >
              <label class="">{{
                $t('certificateOperationPrint.requestDateTo')
              }}</label>
              <a-date-picker
                v-model="model.request_date_to"
                :allowClear="true"
                style="width: 100%"
                placeholder="DD-MM-YYYY"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                @change="onChangeRequestDateto"
                :class="{
                  'is-invalid': errors.has('request_date_to')
                }"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('request_date_to')"
              >
                {{ errors.first('request_date_to') }}
              </div>
            </div>
            <div
              class="col-md-3"
              v-if="model.cert_type_id == 4 || model.cert_type_id == 12"
            >
              <label class="required">{{
                $t('certificateOperationPrint.examDate')
              }}</label>
              <a-date-picker
                v-model="model.exam_date"
                :allowClear="true"
                style="width: 100%"
                placeholder="DD-MM-YYYY"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                @change="onChangeExamdate"
                :class="{
                  'is-invalid': errors.has('request_date_to')
                }"
              />
              <div class="invalid-feedback" v-if="errors.has('exam_date')">
                {{ errors.first('exam_date') }}
              </div>
            </div>
            <div class="col-md-6">
              <label>{{ $t('search') }}</label>
              <a-input
                type="text"
                v-model="search_certificate"
                placeholder="card number|student name|major"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <a-table
                v-if="model.cert_type_id == 18"
                size="small"
                :columns="
                  model.cert_type_id == 8 || model.cert_type_id == 9 
                    ? columns_class
                    : model.cert_type_id == 10
                    ? columns_staff
                    : model.cert_type_id == 18
                    ? columns_honorable
                    : columns
                "
                :data-source="studentLists"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <a-table
                v-else
                size="small"
                :columns="
                  model.cert_type_id == 8 || model.cert_type_id == 9 
                    ? columns_class
                    : model.cert_type_id == 10
                    ? columns_staff
                    : model.cert_type_id == 18
                    ? columns_honorable
                    : model.cert_type_id == 19
                    ? columns_re_exam
                    : columns
                "
                :row-key="studentLists => studentLists.student_id"
                :data-source="studentLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
            </div>
          </div>
        </ts-loading-banner>
      </fieldset>
    </div>
    <div class="row">
      <div class="col-md-12 ts-flex ts-justify-between">
        <div class="ts-flex ts-justify-start text-danger">
          {{ errors.first('student_id_list') }}
        </div>
        <div class="ts-flex ts-justify-end ts-space-x-2">
          <ts-button @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onSave"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'certificateOperationPrintForm',
  data () {
    return {
      loading: false,
      waiting: false,
      fetchingStudent: false,
      fetching: false,
      errors: new Errors(),
      filterClass: false,
      fetcTerm: false,
      fectSubject: false,
      search_certificate: '',
      certificate_types: [],
      ac_year_list: [],
      main_programs: [],
      sub_programs: [],
      students: [],
      classes: [],
      positions: [],
      ac_terms: [],
      class_options: [],
      subjects: [],
      model: {
        request_date: moment().format('DD-MM-YYYY'),
        exam_date: moment().format('DD-MM-YYYY'),
        request_date_to: null,
        cert_type_id: null,
        ac_year_id: null,
        acp_id: [],
        acps_id: [],
        student_id_list: [],
        course_name: null,
        level_and_batch: null,
        position_id: null,
        class_id: null,
        ac_term_id: null,
        subject_name: null,
        doctor_name: null,
        level: null,
        achievement_name: null,
        subject_id: null,
        promotion: null
      },
      boyPhoto: require('@/assets/student-default-boy.png'),
      girlPhoto: require('@/assets/student-default-girl.png')
    }
  },
  computed: {
    columns () {
      return [
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 80
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 150
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name_en'
        },
        {
          title: this.$t('certificateOperationPrint.sex'),
          dataIndex: 'sex',
          width: 70
        },
        {
          title: this.$t('certificateOperationPrint.subProgram'),
          dataIndex: 'major_fields',
          width: 300
        },
        {
          title: this.$t('certificateOperationPrint.degree'),
          dataIndex: 'degree',
          width: 80
        }
      ]
    },
    columns_class () {
      // cert_type_id = 8 or 9
      return [
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 80
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 150
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name_en'
        },
        {
          title: this.$t('certificateOperationPrint.sex'),
          dataIndex: 'sex',
          width: 70
        },
        {
          title: this.$t('certificateOperationPrint.class'),
          dataIndex: 'class_name',
          width: 300
        }
      ]
    },
    columns_re_exam () {
      return [
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 80
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 150
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name_en'
        },
        {
          title: this.$t('certificateOperationPrint.sex'),
          dataIndex: 'sex',
          width: 70
        },
        {
          title: this.$t('certificateOperationPrint.subject'),
          dataIndex: 'subject_name_foreign',
          width: 300
        }
      ]
    },
    columns_staff () {
      // cert_type_id = 10
      return [
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 80
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 150
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name_en'
        },
        {
          title: this.$t('certificateOperationPrint.sex'),
          dataIndex: 'sex',
          width: 70
        },
        {
          title: this.$t('certificateOperationPrint.position'),
          dataIndex: 'pos_name_en',
          width: 300
        }
      ]
    },
    columns_honorable () {
      // cert_type_id = 18
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 80
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 150
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name_en'
        },
        {
          title: this.$t('certificateOperationPrint.sex'),
          dataIndex: 'sex'
        },
        {
          title: this.$t('certificateOperationPrint.rank'),
          dataIndex: 'ranks',
          width: 300
        }
      ]
    },
    studentLists () {
      if (_.isEmpty(this.students)) return []

      if (this.search_certificate) {
        return _.orderBy(this.students, ['card_number'], ['asc']).filter(
          option => {
            if (
              option.card_number === null ||
              option.card_number === undefined ||
              option.student_name_en === null ||
              option.student_name_en === undefined
              //  ||option.major === null ||
              // option.major === undefined
            )
              return false

            return (
              option.card_number
                .toLowerCase()
                .startsWith(this.search_certificate.toLowerCase()) ||
              option.student_name_en
                .toLowerCase()
                .startsWith(this.search_certificate.toLowerCase())
              //   ||
              // option.major
              //   .toLowerCase()
              //   .startsWith(this.search_certificate.toLowerCase())
            )
          }
        )
      }
      if (this.model.cert_type_id == 18) {
        return _.orderBy(this.students, ['ranks'], 'ASC')
      }
      return _.orderBy(this.students, ['card_number'], 'ASC')
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions('certificateOperationPrint', [
      'getYear',
      'getMainProgram',
      'getSubProgram',
      'getCertificateType',
      'getClasses',
      'getPosition',
      'getTerm',
      'getClass',
      'getSubject'
    ]),
    async fetchData () {
      this.loading = true
      await this.getCertificateType().then(response => {
        this.certificate_types = response.data
      })
      await this.getMainProgram().then(response => {
        this.main_programs = response.data.map(el => ({
          id: el.acp_id,
          label: el.acp_name_foreign
        }))
      })
      await this.getYear()
        .then(response => {
          this.ac_year_list = response.data.map(el => ({
            value: el.ac_year_id,
            label:
              el.ac_year +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : '( Next )')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      this.loading = false
    },
    async certTypeChange () {
      this.model.course_name = null
      this.model.level_and_batch = null
      this.students = []
      this.classes = []
      this.positions = []
      this.subjects = []
      if (this.model.cert_type_id == 8 || this.model.cert_type_id == 9) {
      }
      await this.getClasses().then(response => {
        this.classes = response.data.map(el => ({
          value: el.class_id,
          label: el.class_name
        }))
      })
      if (this.model.cert_type_id == 10) {
        await this.getPosition().then(response => {
          this.positions = response.map(el => ({
            value: el.position_id,
            label: el.pos_name_en
          }))
        })
      }
    },
    onMainProgramChange () {
      this.model.acps_id = []
      this.fetching = true
      if (this.model.acp_id.length <= 0) {
        this.fetching = false
        return
      }
      this.getSubProgram({
        filter: {
          acp_id: this.model.acp_id
        }
      })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            id: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    onSubProgramChange () {
      this.model.ac_term_id = []
      this.fetcTerm = true
      if (this.model.acps_id.length <= 0) {
        this.fetching = false
        return
      }
      this.getTerm({
        filter: {
          ac_year_id: this.model.ac_year_id,
          acps_id: this.model.acps_id
        }
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : null)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetcTerm = false
        })
      if (this.model.cert_type_id == 19) {
        this.getSubject({
          filter: {
            acps_id: this.model.acps_id
          }
        }).then(response => {
          this.subjects = response.data.map(el => ({
            value: el.subject_id,
            label: el.subject_name_foreign
          }))
        })
      }
    },
    acTermChange (ac_term_id) {
      this.filterClass = true
      this.model.class_id = []
      if (this.model.cert_type_id == 18) {
        this.getClass({
          filter: {
            ac_term_id: ac_term_id
          }
        })
          .then(response => {
            this.class_options = response.data.map(el => ({
              value: el.class_id,
              label: el.class_name
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.filterClass = false
          })
      } else {
        this.getClass({
          filter: {
            ac_term_id: ac_term_id,
            required_thesis: true
          }
        })
          .then(response => {
            this.class_options = response.data.map(el => ({
              value: el.class_id,
              label: el.class_name
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.filterClass = false
          })
      }
    },
    checkItem (selectedRowKeys, selectedRows) {
      this.model.student_id_list = []
      ;(this.model.doctor_name = null),
      (this.model.subject_name = null),
      selectedRows.forEach(el => {
          this.model.student_id_list.push({
            student_id: el.student_id ? el.student_id : null,
            acps_id: el.acps_id ? el.acps_id : null,
            acp_id: el.acp_id ? el.acp_id : null,
            level_id: el.level_id ? el.level_id : null,
            ac_year_id: this.model.ac_year_id ? this.model.ac_year_id : null,
            cert_type_id: this.model.cert_type_id,
            request_date: this.model.request_date,
            request_date_to: this.model.request_date_to,
            course_name: this.model.course_name,
            level_and_batch: this.model.level_and_batch,
            class_id: el.class_id ? el.class_id : null,
            staff_id: el.staff_id ? el.staff_id : null,
            position_id: el.position_id ? el.position_id : null,
            teacher_id: el.teacher_id ? el.teacher_id : null,
            degree: el.degree,
            registration_id: el.registration_id,
            exam_date: this.model.exam_date,
            subject_id: this.model.subject_id,
          })
        })
    },

    onChangeRequestDate (dateString) {
      this.request_date = dateString
    },
    onChangeRequestDateto (dateString) {
      this.request_date_to = dateString
    },
    onChangeExamdate (dateString) {
      this.exam_date = dateString
    },

    onSave () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('certificateOperationPrint/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    search () {
      this.errors = new Errors()
      this.fetchingStudent = true
      this.$store
        .dispatch('certificateOperationPrint/searchStudent', this.model)
        .then(response => {
          this.students = response.data
        })

        .catch(error => {
          this.$notify({ type: 'errors', text: error.message })
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.fetchingStudent = false
        })
    },
    photoStudent (record) {
      if (record.photo) {
        return record.photo
      }

      return record.sex == 'Male' ? this.boyPhoto : this.girlPhoto
    },

    onError (record) {
      event
        ? (event.target.src =
            record.sex == 'Male' ? this.boyPhoto : this.girlPhoto)
        : ''
    }
  },
  watch: {
    'model.cert_type_id' (newVal) {
      if (newVal === 18 || newVal === 20) {
        this.model.student_id_list = this.studentLists.map(el => ({
          student_id: el.student_id || null,
          acps_id: el.acps_id || null,
          acp_id: el.acp_id || null,
          level_id: el.level_id || null,
          ac_year_id: this.model.ac_year_id || null,
          cert_type_id: this.model.cert_type_id,
          request_date: this.model.request_date,
          request_date_to: this.model.request_date_to,
          course_name: this.model.course_name,
          level_and_batch: this.model.level_and_batch,
          class_id: el.class_id || null,
          staff_id: el.staff_id || null,
          position_id: el.position_id || null,
          teacher_id: el.teacher_id || null,
          degree: el.degree,
          exam_date: this.model.exam_date,
                    registration_id: this.model.registration_id

        }))
      } else {
        this.model.student_id_list = []
      }
    },
    studentLists (newVal) {
      if (this.model.cert_type_id === 18 || this.model.cert_type_id === 20) {
        this.model.student_id_list = newVal.map(el => ({
          student_id: el.student_id || null,
          acps_id: el.acps_id || null,
          acp_id: el.acp_id || null,
          level_id: el.level_id || null,
          ac_year_id: this.model.ac_year_id || null,
          cert_type_id: this.model.cert_type_id,
          request_date: this.model.request_date,
          request_date_to: this.model.request_date_to,
          course_name: this.model.course_name,
          level_and_batch: this.model.level_and_batch,
          class_id: el.class_id || null,
          staff_id: el.staff_id || null,
          position_id: el.position_id || null,
          teacher_id: el.teacher_id || null,
          degree: el.degree,
          exam_date: this.model.exam_date,
          registration_id: this.model.registration_id
        }))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  margin-bottom: 0 !important;
}
</style>
